// import Message from 'shared_components/message';
import { axiosLabAPI } from '../axios';
import { API_GET_METHOD, API_POST_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function createLabRequest(payload) {
	let isSuccess = false;

	// console.log('payload =>', payload);
	
	try {
		const response = await axiosLabAPI({ 
			method: API_POST_METHOD, 
			url: 'request/create',
			data: {
					p_patientid: payload.patientID,
					p_visit: payload.visit,
					p_chargeslip: payload.chargeSlip,
					p_officialreceipt: payload.officialReceipt,
					p_hospitalrequestid: payload.hospitalRequestID,
					p_patientage: payload.patientAge,
					p_locationid: payload.locationID,
					p_bed: payload.bed,
					p_physicianid: payload.physicianID,
					p_comment: payload.comment,
					p_userid: payload.userID,
					p_exams_array: JSON.stringify(payload.exams),
				}
		});

		// eslint-disable-next-line no-unused-vars
		const { data } = await response;

		isSuccess = true;
	} catch (e) {
		// Message.error();
		showMessage(e);
		isSuccess = false;
	}

	return isSuccess;
}

export async function updateLabRequest(payload) {
	let isSuccess = false;
	console.log("🚀 ~ updateLabRequest ~ JSON.stringify(payload.remove):", JSON.stringify(payload.remove))

	try {
		const response = await axiosLabAPI({
			method: API_POST_METHOD,
			url: '/request/edit',
			data: {
				p_request_header_dttm: payload.requestDateTime,
				p_request_header_id: payload.requestID,
				p_patientid: payload.patientID,
				p_visit: payload.visit,
				p_chargeslip: payload.chargeSlip,
				p_officialreceipt: payload.officialReceipt,
				p_hospitalrequestid: payload.hospitalRequestID,
				p_patientage: payload.patientAge,
				p_locationid: payload.locationID,
				p_bed: payload.bed,
				p_physicianid: payload.physicianID,
				p_comment: payload.comment,
				p_userid: payload.userID,
				p_exams_array: JSON.stringify(payload.exams),
				p_exams_remove_array: JSON.stringify(payload.remove),
				
			}
		});
		
		// eslint-disable-next-line no-unused-vars
		const { data } = await response;

		isSuccess = true;
	} catch (e) {
		// Message.error();
		showMessage(e);
		isSuccess = false;
	}

	return isSuccess;
}

export async function fetchPatientsByDate(date) {
	let patients = [];

	try {
		const content = {
			method: API_GET_METHOD,
			url: `/request/search?p_request_datetime=${date}`,
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			patients = data.RECORDS;
		}
	} catch (e) {
		showMessage(e);
	}

	return patients;
}

export async function fetchPatientsById({ id, date }) {
	let patients = [];
	try {
		const content = {
			method: API_GET_METHOD,
			url: `/request/search?p_request_datetime=${date}&p_patient_demographics_id=${id}`,
		};

		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			patients = data.RECORDS;
		}
	} catch (e) {
		showMessage(e);
	}

	return patients;
}

export async function fetchPatientsByName({ name, date }) {
	let patients = [];

	try {
		const content = {
			method: API_GET_METHOD,
			url: `/request/search?p_request_datetime=${date}&p_patient_name=${name}`,
		};
		
		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			patients = data.RECORDS;
		}
	} catch (e) {
		showMessage(e);
	}

	return patients;
}

export async function fetchExamsByReqId(id) {
	let exams = [];

	try {
		const content = {
			method: API_GET_METHOD,
			url: `/request/listofexamsbyrequestid?p_request_header_id=${id}`,
		};
		
		const response = await axiosLabAPI(content);
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			exams = data.RECORDS;
		}
	} catch (e) {
		showMessage(e);
	}
	
  return exams;
}

export async function fetchPatients(patientName, patientID){
		let patients = [];
		const params = patientID ? { p_patient_demographics_id: patientID.trim() } : { p_patient_name: patientName.trim() };
		try {
			const response = await axiosLabAPI({
				method: API_GET_METHOD,
				url: '/patient/info',
				params,
			});

			const { data } = await response;
			console.log('data =>', data);

			// Handle new API response format
			if (data && data.STATUSCODE === 200 && data.RECORDS) {
				patients = data.RECORDS;
			} else {
				patients = [];
			}
			// patients = data ? data.patient : [];
		} catch (error) {
			// Message.error();
			showMessage(error);
		}

		return patients;
};
